import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrg } from '../../../shared/contexts/OrgContext';
import { extractOrgIdFromPath } from '../../../shared/utils/organizationUtils';

const SocialMediaUploadDetailPage: React.FC = () => {
  const { uploadId } = useParams<{ uploadId: string }>();
  const navigate = useNavigate();
  const { currentOrganization } = useOrg();
  const orgIdFromPath = extractOrgIdFromPath(window.location.pathname);
  const orgId = currentOrganization?.id || orgIdFromPath || 'default';

  // Redirect to uploads page and open drawer via state
  useEffect(() => {
    if (uploadId) {
      // Navigate to uploads page, the drawer will be opened via URL state
      navigate(`/o/${orgId}/capture/social-media-uploads`, { 
        state: { openDrawer: true, uploadId } 
      });
    } else {
      navigate(`/o/${orgId}/capture/social-media-uploads`);
    }
  }, [uploadId, orgId, navigate]);

  return null;
};

export default SocialMediaUploadDetailPage;
